:host {
  --uui-input-error-background-color: var(--uui-theme-error-400);
  --uui-input-error-color: var(--uui-theme-secondary-400);
  --uui-input-warning-background-color: var(--uui-theme-warning-400);
  --uui-input-error-fill-color: var(--uui-theme-error-600);
  --uui-input-warning-fill-color: var(--uui-theme-warning-600);
  --uui-input-error-padding: 0.75rem;
}

:host {
  font-family: var(--uui-primary-font-family);
  font-size: var(--uui-default-font-size);
  font-weight: var(--uui-font-weight-normal);
  line-height: var(--uui-default-line-height);
}

:host > div {
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  -webkit-align-items: center;
  align-items: center;
  background-color: var(--uui-input-error-background-color);
  border-radius: 0.25rem;
  padding: var(--uui-input-error-padding);
  margin-bottom: 0.5rem;
}

.uui-input-error-content {
  color: var(--uui-input-error-color);
  margin-right: auto;
  padding-left: 0.625rem;
}

.uui-input-error-icon {
  line-height: 0;
}

svg {
  display: inline-block;
  font-size: inherit;
  height: 1.25rem;
  overflow: visible;
  font-size: var(--uui-default-font-size);
  fill: var(--uui-input-error-fill-color);
}

:host > div[data-mode="warning"] {
  background-color: var(--uui-input-warning-background-color);
}

:host > div[data-mode="warning"] svg {
  fill: var(--uui-input-warning-fill-color);
}
